import NumberStepProgress from "mobily-ui-library/lib/components/block/numberStepProgress/NumberStepProgress";
import { useTranslation } from "react-i18next";
import "./Progress.scss";
import { GlobalContext } from "../../../context/GlobalContext";
import { useContext } from "react";

export interface Props {
  rtl: boolean;
  title: string;
}

function Progress({ rtl, title }: Props) {
  const { t } = useTranslation();
      const [state]: any = useContext(GlobalContext);
      const { productType } = state;

  const steps = [
    {
      label: t("Account_Information"),
      stepcheck: false,
      cancelled: false,
      date: "",
    },
    {
      label: t("Product_Information"),
      stepcheck: false,
      cancelled: false,
      date: "",
    },
    {
      label: t("Delivery_Details"),
      stepcheck: false,
      cancelled: false,
      date: "",
    },
    {
      label: t("Download_Attach"),
      stepcheck: false,
      cancelled: false,
      date: "",
    },
    {
      label: t("Order_Summary"),
      stepcheck: false,
      cancelled: false,
      date: "",
    }
  ];

  const objIndex = steps.findIndex(obj => obj.label === title)
  if (steps[objIndex].label === title) {
    if(productType !== "Voice" && productType !== "Data" ){
      steps.splice(2,1);
    }
    for (let i = 0; i <= objIndex; i++) {

      steps[i].stepcheck = true;
    }
  }
  // console.log(steps);
  const ProgressRight = () => {
    return (
      <div className="col-sm-12">
        <NumberStepProgress steps={steps} rtl={rtl} />
      </div>
    )
  }

  const ProgressLeft = () => {
    return (
      <div className="col-sm-12">
        <NumberStepProgress steps={steps} rtl={rtl} />
      </div>
    )
  }

  const dir = rtl ? 'right' : 'left'

  return (
    <div className={`col-sm-12 progress-container fontFamily-${dir}`}>
      {rtl ? <ProgressRight /> : <ProgressLeft />}
    </div>
  );
}

export default Progress;
